import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, isMobile, toggleSidebar }) => {
  const location = useLocation();
  const SIDEBAR_WIDTH = 150;

  const linkStyle = (path) => ({
    display: 'block',
    padding: '0.8rem 1rem',
    marginBottom: '0.5rem',
    borderRadius: '8px',
    color: location.pathname === path ? '#1976d2' : '#333',
    backgroundColor:
      location.pathname === path
        ? 'rgba(227, 242, 253, 0.9)'
        : 'transparent',
    textDecoration: 'none',
    fontWeight: location.pathname === path ? '600' : '500',
    fontSize: '1.1rem',
    transition: 'all 0.2s ease',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
  });

  const buttonStyle = {
    // Container for the logo/title and the close button (for mobile)
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem',
    marginBottom: '1.5rem',
    color: '#1976d2',
    padding: '0.5rem',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: 'transparent',
  };

  const closeIconStyle = {
    // Style for the 'X' button only
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.5rem',
    color: '#1976d2',
    padding: '0.5rem',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
  }

  const sidebarStyle = {
    position: 'fixed',
    left: 0,
    top: 0,
    height: '100vh',
    zIndex: 999,

    width: SIDEBAR_WIDTH,
    // FIX: Hides the sidebar completely off-screen on mobile when closed
    transform: isMobile && !isOpen ? `translateX(-${SIDEBAR_WIDTH}px)` : 'translateX(0)',

    transition: 'transform 0.3s ease, background 0.2s ease, box-shadow 0.2s ease',

    background: 'rgba(248, 250, 255, 0.95)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    padding: '1.2rem',
    overflowY: 'auto',

    boxShadow: isOpen && isMobile ? '2px 0 12px rgba(0,0,0,0.2)' : (isOpen ? '2px 0 12px rgba(0,0,0,0.05)' : 'none'),

    // FIX: Removes the lingering border when the sidebar is closed on mobile
    borderRight: isMobile && !isOpen ? 'none' : '1px solid rgba(230, 230, 230, 0.7)',
  };

  return (
    <>
      <div
        className="sidebar"
        style={sidebarStyle}
      >

        {/* Logo/Close Button - Visible ONLY when the sidebar is OPEN or on DESKTOP */}
        {isOpen && (
          <div style={buttonStyle}>
            {/* Logo and App Title */}
            {/* <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}> */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src="/android-chrome-512x512.png"
                  alt="OMGJLPT Logo"
                  style={{
                    width: '40px',
                    height: '40px',
                    verticalAlign: 'middle',
                    marginRight: '8px',
                  }}
                />
                <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>JLPT</span>
              </div>
            {/* </a> */}


            {/* Close Icon (Only show on mobile when open) */}
            {isMobile && (
              <button
                onClick={toggleSidebar}
                style={closeIconStyle}
                aria-label="Close sidebar"
              >
                ✕
              </button>
            )}
          </div>
        )}

        {/* Navigation Links */}
        <div style={{ clear: 'both' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['n5', 'n4', 'n3', 'n2', 'n1'].map((level) => (
              <li key={level}>
                <Link
                  to={`/old_questions/${level}`}
                  style={linkStyle(`/old_questions/${level}`)}
                  onClick={isMobile ? toggleSidebar : undefined}
                >
                  {level.toUpperCase()} Level
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <style>{`
        .sidebar button:hover {
          background-color: rgba(75, 134, 202, 0.9) !important;
        }

        .sidebar a:hover {
          background-color: rgba(173, 204, 240, 0.9) !important;
          transform: translateX(4px);
        }
      `}</style>
    </>
  );
};

export default Sidebar;